module.exports = __webpack_public_path__ + "static/media/broker-poster.620ff9ff.jpg";